import { Component } from '@angular/core';
import { Router }    from '@angular/router';

import { PatientService }  from '../../services/patients/patient.service';

import { UserSearchComponent } from '../../users/search/user-search.component';

@Component({
  moduleId: module.id,
  selector: 'patient-search',
  templateUrl: '../../users/search/user-search.component.html',
  styleUrls: [ '../../users/search/user-search.component.css' ]
})

export class PatientSearchComponent extends UserSearchComponent {

  constructor(
    protected router: Router,
    protected patientService: PatientService) { super(router, patientService); }

  protected getDetailUrl(): string {

    return '/patient/';
  };

  protected getUserString(): string {

    return 'Patient';
  };
}


// WEBPACK FOOTER //
// ./src/app/patients/search/patient-search.component.ts